import { gql } from "@apollo/client";

export const AddMrf = gql`
  mutation AddMrf(
    $token: String!
    $customerId: ID!
    $finYrId: ID!
    $user_details: SubscribedUser!
    $input: CreateMrf!
  ) {
    AddMrf(
      token: $token
      customerId: $customerId
      finYrId: $finYrId
      user_details: $user_details
      input: $input
    )
  }
`;

export const DeleteDraftMrf = gql`
  mutation DeleteDraftMrf(
    $token: String!
    $customerId: ID!
    $finYrId: ID!
    $mrfId: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteDraftMrf(
      token: $token
      customerId: $customerId
      finYrId: $finYrId
      mrfId: $mrfId
      user_details: $user_details
    )
  }
`;

export const UpdateDraftMrf = gql`
  mutation UpdateDraftMrf(
    $token: String!
    $customerId: ID!
    $finYrId: ID!
    $mrfId: ID!
    $user_details: SubscribedUser!
    $input: UpdateMrf!
  ) {
    UpdateDraftMrf(
      token: $token
      customerId: $customerId
      finYrId: $finYrId
      mrfId: $mrfId
      user_details: $user_details
      input: $input
    )
  }
`;

export const UpdateItemInMrfTrn = gql`
  mutation UpdateItemInMrfTrn(
    $token: String!
    $customerId: ID!
    $finYrId: ID!
    $mrfId: ID!
    $user_details: SubscribedUser!
    $input: [UpdateMrfItemList!]!
    $trnDate: Time!
  ) {
    UpdateItemInMrfTrn(
      token: $token
      customerId: $customerId
      finYrId: $finYrId
      mrfId: $mrfId
      user_details: $user_details
      input: $input
      trnDate: $trnDate
    )
  }
`;

export const ApproveOrRejectMrf = gql`
  mutation ApproveOrRejectMrf(
    $token: String!
    $customerId: ID!
    $finYrId: ID!
    $mrfId: ID!
    $user_details: SubscribedUser!
    $input: ApproveMrfData!
    $todaysDate: Time!
  ) {
    ApproveOrRejectMrf(
      token: $token
      customerId: $customerId
      finYrId: $finYrId
      mrfId: $mrfId
      user_details: $user_details
      input: $input
      todaysDate: $todaysDate
    )
  }
`;
